var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZipIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon | ZIP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.331 38a.66.66 0 0 0 .669-.65V9.194a.63.63 0 0 0-.191-.449l-6.745-6.56A.66.66 0 0 0 26.603 2H6.669A.66.66 0 0 0 6 2.65v34.7c0 .358.3.65.669.65h26.665-.003Z",
    fill: "#E8EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.873 2v5.413c0 .865.718 1.568 1.601 1.568H34L26.873 2Z",
    fill: "#CFDBE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 27.714v9.624c0 .365.3.662.669.662h26.665c.37 0 .67-.297.67-.662v-9.624H6Z",
    fill: "#F1A841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.875 33.842h-1.783V32.74h1.783c.276 0 .5-.044.674-.132a.855.855 0 0 0 .38-.377c.08-.16.12-.34.12-.542 0-.204-.04-.394-.12-.57a.958.958 0 0 0-.38-.423c-.174-.107-.398-.16-.674-.16h-1.283v5.75h-1.443v-6.857h2.726c.549 0 1.018.097 1.409.292.394.191.696.456.904.796.208.339.312.727.312 1.163 0 .443-.104.826-.312 1.149-.208.323-.51.573-.904.749-.391.176-.86.264-1.409.264ZM20.575 29.429v6.857h-1.438v-6.857h1.438ZM17.899 35.184v1.102h-4.962v-1.102H17.9Zm-.072-4.969-4.25 6.07h-1.014v-.81l4.283-6.046h.98v.786Zm-.495-.786v1.107h-4.765v-1.107h4.765Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1A841",
    d: "M18.25 2H20v1.714h-1.75zM18.25 5.429H20v1.714h-1.75zM18.25 8.857H20v1.714h-1.75zM18.25 12.286H20V14h-1.75zM20 3.714h1.75v1.714H20zM20 7.143h1.75v1.714H20zM20 10.571h1.75v1.714H20zM20 14h1.75v1.714H20zM19.125 16.571h1.75l1.473 4.33a.85.85 0 0 1-.407 1.022.637.637 0 0 1-.305.062H18.364a.637.637 0 0 1-.305-.062.85.85 0 0 1-.407-1.022l1.473-4.33Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipIcon);
export default __webpack_public_path__ + "static/media/ZIPIcon.a0cb3f3890dc36279ba59018a55bb76e.svg";
export { ForwardRef as ReactComponent };